module.exports = __webpack_public_path__ + "static/media/md-move.994962c5.svg";